import {useState} from "react";
import {useAppContext} from "./useAppContext";

export const useEmployeeNotificationBanner = () => {
    const {productId, primaryId} = useAppContext();
    const [isBannerVisible, setIsBannerVisible] = useState<boolean>(true);
    return {
        productId,
        primaryId,
        isVariantProduct: !!primaryId,
        show: isBannerVisible,
        onClose: () => setIsBannerVisible(false)
    }
}